import { Injectable } from '@angular/core';

/**
 * Class for managing stylesheets. Stylesheets are loaded into named slots so that they can be
 * removed or changed later.
 */
@Injectable({ providedIn: 'root' })
export class StyleManager {
  /**
   * Set the stylesheet with the specified key.
   */
  // tslint:disable-next-line:typedef
  setStyle(key: string, href: string) {
    getLinkElementForKey(key).setAttribute('href', href);
  }
}
// tslint:disable-next-line:typedef
function getLinkElementForKey(key: string) {
  return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

// tslint:disable-next-line:typedef
function getExistingLinkElementByKey(key: string) {
  return document.head.querySelector(
    `link[rel="stylesheet"].${getClassNameForKey(key)}`
  );
}

// tslint:disable-next-line:typedef
function createLinkElementWithKey(key: string) {
  const linkEl = document.createElement('link');
  linkEl.setAttribute('rel', 'stylesheet');
  linkEl.classList.add(getClassNameForKey(key));
  document.head.appendChild(linkEl);
  return linkEl;
}

// tslint:disable-next-line:typedef
function getClassNameForKey(key: string) {
  return `style-manager-${key}`;
}
